import addItemForm from "./addItemForm";
export default {
  uploadImageButtonText: addItemForm.uploadImageButtonText,
  cancel: "cancel",
  cropSave: "cropSave",
};
